<template>
<div class="wrap">
   <router-view />
</div>
</template>

<script>
export default {
  
}
</script>
